import React, { useState, useEffect } from 'react'
import { Link, RouteComponentProps, useHistory } from 'react-router-dom'
import { serverConn } from '../../API/apiRequest'
import { Button } from '../../components/Button/Button'
import { Logo } from '../../components/Logo/Logo'
import TextField from '../../components/TextField/TextField'
import queryString from 'query-string'
import validator from 'validator'
const ResetPassword: React.FC<RouteComponentProps<{id: string}>> = (props)=>{

    const [password, setPassword] = useState('')
    const [confirm, setConfirm] = useState('')
    const [loading, setLoading] = useState(false)
    const [err, setErr] = useState('')
    const history = useHistory()
    let query = queryString.parse(props.location.search)
    
    useEffect(()=>{
        function checkState(){
            console.log(props.match.params.id)
            if(!validator.isMongoId(props.match.params.id))
             return history.replace('/404')
            if(!query.code)
             return history.replace('/404')
        }
        checkState()
    // eslint-disable-next-line
    },[])

    const changePassword = async()=>{
        try{
            if(password.trim() === '' || confirm.trim() === '')
            return
            if(password !== confirm)
            return setErr('كلمة المرور غير متطابقة')
            setLoading(true)
            let response = await serverConn.post(`/reset/${props.match.params.id}?code=${query.code}`, {password})
            if(response.status === 200){
             setLoading(false)
             history.replace('/login')
            }
        }catch(e: any){
          if(e.response && e.response.status === 422){
            setErr(e.response.data.errors[0])
          }
          if(e.response && e.response.status === 404){
            setErr('لا يوجد حساب خاص بهذا الرايط')
          }
          setLoading(false)
        }
    }

    const onChangePassword = ({target}: React.ChangeEvent<HTMLInputElement>)=>{
        setPassword(target.value)
        setErr('')
    }
    const onChangeConfirm = ({target}: React.ChangeEvent<HTMLInputElement>)=>{
        setConfirm(target.value)
        setErr('')
    }

    return(
        <div style={{display: 'flex', backgroundColor: '#1D252D', minHeight: '100vh', alignItems: 'flex-start', flexDirection: 'column'}}>
            <Link to='/' style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: 20}}>
                <Logo />
            </Link>
            <div style={{width: '100%', marginTop: 25}}>
                <h2 style={{color: '#fff', textAlign: 'center'}}>
                    تحديث كلمة المرور
                </h2>
            </div>
            <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column', width: '100%', marginTop: 30}}>
            <div style={{backgroundColor: '#343a40', padding: 30, borderRadius: 5}}>
            <div style={{
                display: 'flex', 
                justifyContent: 'flex-start', 
                alignItems: 'flex-end', 
                flexDirection: 'column',
            }}>
                <p style={{color: '#fff', margin: 0, padding: 0}}>كلمة المرور الجديدة</p>
                <TextField 
                  placeholder='كلمة المرور الجديدة'
                  handleChange={onChangePassword}
                  type='password'
                />
            </div>
            <div style={{
                display: 'flex', 
                justifyContent: 'flex-start', 
                alignItems: 'flex-end', 
                flexDirection: 'column',
                marginTop: 30
            }}>
                <p style={{color: '#fff', margin: 0, padding: 0}}>تأكيد كلمة المرور الجديدة</p>
                <TextField 
                  placeholder='كلمة المرور الجديدة'
                  handleChange={onChangeConfirm}
                  type='password'
                />
            </div>
            </div>
            {err && <p style={{color: 'tomato', margin: 0, padding: 0, marginTop: 10}}>{err}</p>}
            <Button loading={loading} style={{marginTop: 20}} onPress={changePassword}>حفظ</Button>
            </div>
        </div>
    )
}

export default ResetPassword